// import instantpage from 'instant.page'
import Alpine from 'alpinejs'
import intersect from '@alpinejs/intersect'
import swipePlugin from "alpinejs-swipe";
import mask from '@alpinejs/mask'
import { Island } from '@11ty/is-land'

Alpine.plugin(mask)
Alpine.plugin(swipePlugin);
Alpine.plugin(intersect)
Alpine.start()
